import styled from "styled-components";

interface FormContainerProps {
  size?: string;
  border?: boolean;
}

export const EditarCamposContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  height: 100%;
  padding: 1rem;
  box-sizing: border-box;
`;

export const DivFlex = styled.div`
  display: flex;
`;

export const TitleForm = styled.div`
  display: flex;
  label {
    font-weight: 600;
    font-size: 14px;

    line-height: 20px;
    text-align: start;
  }

  label:first-child {
    width: 54%;
  }
`;

export const FormContainer = styled.div<FormContainerProps>`
  width: ${({ size }) => size || "100%"};
  height: 60vh;
  overflow: hidden;
  padding: 0.5rem 1rem;

  border-left: ${({ border }) => (border ? "1px solid var(--border)" : "none")};

  h1 {
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    text-align: start;

    margin: 0;
  }

  h2 {
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    text-align: start;

    margin: 0;
  }

  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const FieldList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  overflow-y: auto;
  flex: 1;
`;

export const ZendeskFieldItem = styled.div`
  padding: 0.4rem 0.5rem;
  font-size: 13px;
  cursor: pointer;
  border-radius: 4px;
  color: var(--color-text);

  &:hover {
    background-color: var(--color-neutral-100, #f3f4f4);
  }
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  overflow-y: auto;
  flex: 1;
  min-height: 0;
`;

export const LinkedFieldRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 32px 1fr;
  align-items: center;
  gap: 0.5rem;
`;

export const TrashBtn = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: var(--color-red-600, #cc3340);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  flex-shrink: 0;

  &:hover {
    opacity: 0.7;
  }
`;

export const InfoContainer = styled.div`
  padding: 1rem 1rem 1rem 40px;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 4px;

  border: 1px solid var(--border);
  border-radius: 8px;

  button {
    padding: 4px;
    position: absolute;
    top: 0.5rem;
    right: 1rem;

    background-color: transparent;
    border: none;
    cursor: pointer;
  }

  p {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    text-align: start;
    margin: 0;
  }
`;

export const InfoIconWrapper = styled.div`
  position: absolute;
  left: 1rem;
  top: calc(1rem + 3px);
  display: flex;
  color: #1f73b7;
`;

export const ButtonContainerStyled = styled.div`
  margin-top: auto;
  margin-bottom: 0;
  margin-left: auto;
`;
